import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import { AuthProvider } from "./context/AuthContext";
import { HelmetProvider } from "react-helmet-async";
import ReactGA from "react-ga4";
//import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const isProd = import.meta.env.PROD;
const isDev = import.meta.env.DEV;

// ----------------------------------------------------
// 🛡️ Global error handling
// ----------------------------------------------------
window.addEventListener("error", (e) => {
  // Ignore common 3rd-party script CORS noise
  if (e.message === "Script error." && !e.filename) {
    if (isDev) {
      console.warn("⚠️ Ignored 3rd-party script error (CORS)");
    }
    return true;
  }

  if (isDev) {
    console.error("❌ Uncaught error:", e);
  }
});

window.addEventListener("unhandledrejection", (e) => {
  if (isDev) {
    console.error("❌ Unhandled promise rejection:", e.reason);
  }
});

// ----------------------------------------------------
// 📈 GA4 initialization
// ----------------------------------------------------
ReactGA.initialize("G-PWEDMPF831", {
  gtagOptions: {
    send_page_view: false,
    anonymize_ip: true,
  },
  debug_mode: isDev,
});

// ----------------------------------------------------
// 🔧 Service Worker (prod only)
// ----------------------------------------------------
//serviceWorkerRegistration.unregister();

// ----------------------------------------------------
// 🚀 Render App
// ----------------------------------------------------
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  // <React.StrictMode>
  <HelmetProvider>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </HelmetProvider>,
  // </React.StrictMode>,
);
